var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcForward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.3 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_forward") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.35,39a1,1,0,0,1-.66-.25,1,1,0,0,1-.1-1.41l11.31-13a1,1,0,1,1,1.51,1.31l-11.31,13A1,1,0,0,1,19.35,39Z",
    transform: "translate(-18.35 -11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.65,26a1,1,0,0,1-.75-.34l-11.31-13a1,1,0,0,1,1.51-1.32l11.31,13a1,1,0,0,1-.1,1.41A1,1,0,0,1,30.65,26Z",
    transform: "translate(-18.35 -11)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcForward);
export default __webpack_public_path__ + "static/media/ic_forward.a470d513c273dd26248a859a06de6b2f.svg";
export { ForwardRef as ReactComponent };